import * as Yup from "yup";
import { StringValidation } from "../PlanSchema";

export const ObjectiveSchema = Yup.object().shape({
  name: StringValidation.label("Objective name"),
});
